import React, { useEffect, useState } from "react";

const sections = [
  { id: "hero", label: "Overview" },
  { id: "human-mobility", label: "Mobility" },
  { id: "use-cases", label: "Projects" },
  { id: "contact-section", label: "Team" },
];

const SectionSpine = () => {
  const [active, setActive] = useState("hero");

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio);
        if (visible[0]) setActive(visible[0].target.id);
      },
      { rootMargin: "-45% 0px -45% 0px", threshold: [0, 0.25, 0.5, 0.75, 1] }
    );

    sections.forEach(({ id }) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  const handleClick = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <nav
      aria-label="Page sections"
      className="hidden xl:block fixed right-6 top-1/2 -translate-y-1/2 z-40"
    >
      <ul className="flex flex-col gap-1">
        {sections.map(({ id, label }) => {
          const isActive = active === id;
          return (
            <li key={id}>
              <button
                onClick={() => handleClick(id)}
                className="group flex items-center gap-3 cursor-pointer py-2 pr-2"
                aria-label={`Jump to ${label}`}
                aria-current={isActive ? "true" : undefined}
              >
                <span
                  className={`text-xs font-medium tracking-tight transition-colors duration-200 ${
                    isActive
                      ? "text-ink"
                      : "text-ink-faint group-hover:text-ink-soft"
                  }`}
                >
                  {label}
                </span>
                <span
                  className={`block rounded-full transition-all duration-300 flex-shrink-0 ${
                    isActive
                      ? "w-2 h-2 bg-brand-500"
                      : "w-1.5 h-1.5 bg-paper-400 group-hover:bg-ink-subtle"
                  }`}
                />
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default SectionSpine;
